/**
 * ApiGest API
 * ApiGest API documentation
 *
 * OpenAPI spec version: 1.0.0
 * Contact: info@eneasys.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { TenantContextDTO } from '../model/tenantContextDTO';

import { AIG_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class TenantContextResourceService {

    protected basePath = 'https://api-gest.eneasys.net';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(AIG_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * countTenantContexts
     * 
     * @param contextCodeContains 
     * @param contextCodeDoesNotContain 
     * @param contextCodeEquals 
     * @param contextCodeIn 
     * @param contextCodeNotEquals 
     * @param contextCodeSpecified 
     * @param idEquals 
     * @param idGreaterThan 
     * @param idGreaterThanOrEqual 
     * @param idIn 
     * @param idLessThan 
     * @param idLessThanOrEqual 
     * @param idNotEquals 
     * @param idSpecified 
     * @param logoImageContains 
     * @param logoImageDoesNotContain 
     * @param logoImageEquals 
     * @param logoImageIn 
     * @param logoImageNotEquals 
     * @param logoImageSpecified 
     * @param nameContains 
     * @param nameDoesNotContain 
     * @param nameEquals 
     * @param nameIn 
     * @param nameNotEquals 
     * @param nameSpecified 
     * @param nameDatabaseContains 
     * @param nameDatabaseDoesNotContain 
     * @param nameDatabaseEquals 
     * @param nameDatabaseIn 
     * @param nameDatabaseNotEquals 
     * @param nameDatabaseSpecified 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public countTenantContextsUsingGET(contextCodeContains?: string, contextCodeDoesNotContain?: string, contextCodeEquals?: string, contextCodeIn?: Array<string>, contextCodeNotEquals?: string, contextCodeSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, logoImageContains?: string, logoImageDoesNotContain?: string, logoImageEquals?: string, logoImageIn?: Array<string>, logoImageNotEquals?: string, logoImageSpecified?: boolean, nameContains?: string, nameDoesNotContain?: string, nameEquals?: string, nameIn?: Array<string>, nameNotEquals?: string, nameSpecified?: boolean, nameDatabaseContains?: string, nameDatabaseDoesNotContain?: string, nameDatabaseEquals?: string, nameDatabaseIn?: Array<string>, nameDatabaseNotEquals?: string, nameDatabaseSpecified?: boolean, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public countTenantContextsUsingGET(contextCodeContains?: string, contextCodeDoesNotContain?: string, contextCodeEquals?: string, contextCodeIn?: Array<string>, contextCodeNotEquals?: string, contextCodeSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, logoImageContains?: string, logoImageDoesNotContain?: string, logoImageEquals?: string, logoImageIn?: Array<string>, logoImageNotEquals?: string, logoImageSpecified?: boolean, nameContains?: string, nameDoesNotContain?: string, nameEquals?: string, nameIn?: Array<string>, nameNotEquals?: string, nameSpecified?: boolean, nameDatabaseContains?: string, nameDatabaseDoesNotContain?: string, nameDatabaseEquals?: string, nameDatabaseIn?: Array<string>, nameDatabaseNotEquals?: string, nameDatabaseSpecified?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public countTenantContextsUsingGET(contextCodeContains?: string, contextCodeDoesNotContain?: string, contextCodeEquals?: string, contextCodeIn?: Array<string>, contextCodeNotEquals?: string, contextCodeSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, logoImageContains?: string, logoImageDoesNotContain?: string, logoImageEquals?: string, logoImageIn?: Array<string>, logoImageNotEquals?: string, logoImageSpecified?: boolean, nameContains?: string, nameDoesNotContain?: string, nameEquals?: string, nameIn?: Array<string>, nameNotEquals?: string, nameSpecified?: boolean, nameDatabaseContains?: string, nameDatabaseDoesNotContain?: string, nameDatabaseEquals?: string, nameDatabaseIn?: Array<string>, nameDatabaseNotEquals?: string, nameDatabaseSpecified?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public countTenantContextsUsingGET(contextCodeContains?: string, contextCodeDoesNotContain?: string, contextCodeEquals?: string, contextCodeIn?: Array<string>, contextCodeNotEquals?: string, contextCodeSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, logoImageContains?: string, logoImageDoesNotContain?: string, logoImageEquals?: string, logoImageIn?: Array<string>, logoImageNotEquals?: string, logoImageSpecified?: boolean, nameContains?: string, nameDoesNotContain?: string, nameEquals?: string, nameIn?: Array<string>, nameNotEquals?: string, nameSpecified?: boolean, nameDatabaseContains?: string, nameDatabaseDoesNotContain?: string, nameDatabaseEquals?: string, nameDatabaseIn?: Array<string>, nameDatabaseNotEquals?: string, nameDatabaseSpecified?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

































        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (contextCodeContains !== undefined && contextCodeContains !== null) {
            queryParameters = queryParameters.set('contextCode.contains', <any>contextCodeContains);
        }
        if (contextCodeDoesNotContain !== undefined && contextCodeDoesNotContain !== null) {
            queryParameters = queryParameters.set('contextCode.doesNotContain', <any>contextCodeDoesNotContain);
        }
        if (contextCodeEquals !== undefined && contextCodeEquals !== null) {
            queryParameters = queryParameters.set('contextCode.equals', <any>contextCodeEquals);
        }
        if (contextCodeIn) {
            contextCodeIn.forEach((element) => {
                queryParameters = queryParameters.append('contextCode.in', <any>element);
            })
        }
        if (contextCodeNotEquals !== undefined && contextCodeNotEquals !== null) {
            queryParameters = queryParameters.set('contextCode.notEquals', <any>contextCodeNotEquals);
        }
        if (contextCodeSpecified !== undefined && contextCodeSpecified !== null) {
            queryParameters = queryParameters.set('contextCode.specified', <any>contextCodeSpecified);
        }
        if (idEquals !== undefined && idEquals !== null) {
            queryParameters = queryParameters.set('id.equals', <any>idEquals);
        }
        if (idGreaterThan !== undefined && idGreaterThan !== null) {
            queryParameters = queryParameters.set('id.greaterThan', <any>idGreaterThan);
        }
        if (idGreaterThanOrEqual !== undefined && idGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.greaterThanOrEqual', <any>idGreaterThanOrEqual);
        }
        if (idIn) {
            idIn.forEach((element) => {
                queryParameters = queryParameters.append('id.in', <any>element);
            })
        }
        if (idLessThan !== undefined && idLessThan !== null) {
            queryParameters = queryParameters.set('id.lessThan', <any>idLessThan);
        }
        if (idLessThanOrEqual !== undefined && idLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.lessThanOrEqual', <any>idLessThanOrEqual);
        }
        if (idNotEquals !== undefined && idNotEquals !== null) {
            queryParameters = queryParameters.set('id.notEquals', <any>idNotEquals);
        }
        if (idSpecified !== undefined && idSpecified !== null) {
            queryParameters = queryParameters.set('id.specified', <any>idSpecified);
        }
        if (logoImageContains !== undefined && logoImageContains !== null) {
            queryParameters = queryParameters.set('logoImage.contains', <any>logoImageContains);
        }
        if (logoImageDoesNotContain !== undefined && logoImageDoesNotContain !== null) {
            queryParameters = queryParameters.set('logoImage.doesNotContain', <any>logoImageDoesNotContain);
        }
        if (logoImageEquals !== undefined && logoImageEquals !== null) {
            queryParameters = queryParameters.set('logoImage.equals', <any>logoImageEquals);
        }
        if (logoImageIn) {
            logoImageIn.forEach((element) => {
                queryParameters = queryParameters.append('logoImage.in', <any>element);
            })
        }
        if (logoImageNotEquals !== undefined && logoImageNotEquals !== null) {
            queryParameters = queryParameters.set('logoImage.notEquals', <any>logoImageNotEquals);
        }
        if (logoImageSpecified !== undefined && logoImageSpecified !== null) {
            queryParameters = queryParameters.set('logoImage.specified', <any>logoImageSpecified);
        }
        if (nameContains !== undefined && nameContains !== null) {
            queryParameters = queryParameters.set('name.contains', <any>nameContains);
        }
        if (nameDoesNotContain !== undefined && nameDoesNotContain !== null) {
            queryParameters = queryParameters.set('name.doesNotContain', <any>nameDoesNotContain);
        }
        if (nameEquals !== undefined && nameEquals !== null) {
            queryParameters = queryParameters.set('name.equals', <any>nameEquals);
        }
        if (nameIn) {
            nameIn.forEach((element) => {
                queryParameters = queryParameters.append('name.in', <any>element);
            })
        }
        if (nameNotEquals !== undefined && nameNotEquals !== null) {
            queryParameters = queryParameters.set('name.notEquals', <any>nameNotEquals);
        }
        if (nameSpecified !== undefined && nameSpecified !== null) {
            queryParameters = queryParameters.set('name.specified', <any>nameSpecified);
        }
        if (nameDatabaseContains !== undefined && nameDatabaseContains !== null) {
            queryParameters = queryParameters.set('nameDatabase.contains', <any>nameDatabaseContains);
        }
        if (nameDatabaseDoesNotContain !== undefined && nameDatabaseDoesNotContain !== null) {
            queryParameters = queryParameters.set('nameDatabase.doesNotContain', <any>nameDatabaseDoesNotContain);
        }
        if (nameDatabaseEquals !== undefined && nameDatabaseEquals !== null) {
            queryParameters = queryParameters.set('nameDatabase.equals', <any>nameDatabaseEquals);
        }
        if (nameDatabaseIn) {
            nameDatabaseIn.forEach((element) => {
                queryParameters = queryParameters.append('nameDatabase.in', <any>element);
            })
        }
        if (nameDatabaseNotEquals !== undefined && nameDatabaseNotEquals !== null) {
            queryParameters = queryParameters.set('nameDatabase.notEquals', <any>nameDatabaseNotEquals);
        }
        if (nameDatabaseSpecified !== undefined && nameDatabaseSpecified !== null) {
            queryParameters = queryParameters.set('nameDatabase.specified', <any>nameDatabaseSpecified);
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<number>('get',`${this.basePath}/m8t/api/tenant-contexts/count`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * createTenantContext
     * 
     * @param body tenantContextDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createTenantContextUsingPOST(body: TenantContextDTO, observe?: 'body', reportProgress?: boolean): Observable<TenantContextDTO>;
    public createTenantContextUsingPOST(body: TenantContextDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TenantContextDTO>>;
    public createTenantContextUsingPOST(body: TenantContextDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TenantContextDTO>>;
    public createTenantContextUsingPOST(body: TenantContextDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createTenantContextUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<TenantContextDTO>('post',`${this.basePath}/m8t/api/tenant-contexts`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteTenantContext
     * 
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteTenantContextUsingDELETE(id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteTenantContextUsingDELETE(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteTenantContextUsingDELETE(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteTenantContextUsingDELETE(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteTenantContextUsingDELETE.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/m8t/api/tenant-contexts/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getAllTenantContexts
     * 
     * @param contextCodeContains 
     * @param contextCodeDoesNotContain 
     * @param contextCodeEquals 
     * @param contextCodeIn 
     * @param contextCodeNotEquals 
     * @param contextCodeSpecified 
     * @param idEquals 
     * @param idGreaterThan 
     * @param idGreaterThanOrEqual 
     * @param idIn 
     * @param idLessThan 
     * @param idLessThanOrEqual 
     * @param idNotEquals 
     * @param idSpecified 
     * @param logoImageContains 
     * @param logoImageDoesNotContain 
     * @param logoImageEquals 
     * @param logoImageIn 
     * @param logoImageNotEquals 
     * @param logoImageSpecified 
     * @param nameContains 
     * @param nameDoesNotContain 
     * @param nameEquals 
     * @param nameIn 
     * @param nameNotEquals 
     * @param nameSpecified 
     * @param nameDatabaseContains 
     * @param nameDatabaseDoesNotContain 
     * @param nameDatabaseEquals 
     * @param nameDatabaseIn 
     * @param nameDatabaseNotEquals 
     * @param nameDatabaseSpecified 
     * @param page Page number of the requested page
     * @param size Size of a page
     * @param sort Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllTenantContextsUsingGET(contextCodeContains?: string, contextCodeDoesNotContain?: string, contextCodeEquals?: string, contextCodeIn?: Array<string>, contextCodeNotEquals?: string, contextCodeSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, logoImageContains?: string, logoImageDoesNotContain?: string, logoImageEquals?: string, logoImageIn?: Array<string>, logoImageNotEquals?: string, logoImageSpecified?: boolean, nameContains?: string, nameDoesNotContain?: string, nameEquals?: string, nameIn?: Array<string>, nameNotEquals?: string, nameSpecified?: boolean, nameDatabaseContains?: string, nameDatabaseDoesNotContain?: string, nameDatabaseEquals?: string, nameDatabaseIn?: Array<string>, nameDatabaseNotEquals?: string, nameDatabaseSpecified?: boolean, page?: number, size?: number, sort?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<TenantContextDTO>>;
    public getAllTenantContextsUsingGET(contextCodeContains?: string, contextCodeDoesNotContain?: string, contextCodeEquals?: string, contextCodeIn?: Array<string>, contextCodeNotEquals?: string, contextCodeSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, logoImageContains?: string, logoImageDoesNotContain?: string, logoImageEquals?: string, logoImageIn?: Array<string>, logoImageNotEquals?: string, logoImageSpecified?: boolean, nameContains?: string, nameDoesNotContain?: string, nameEquals?: string, nameIn?: Array<string>, nameNotEquals?: string, nameSpecified?: boolean, nameDatabaseContains?: string, nameDatabaseDoesNotContain?: string, nameDatabaseEquals?: string, nameDatabaseIn?: Array<string>, nameDatabaseNotEquals?: string, nameDatabaseSpecified?: boolean, page?: number, size?: number, sort?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TenantContextDTO>>>;
    public getAllTenantContextsUsingGET(contextCodeContains?: string, contextCodeDoesNotContain?: string, contextCodeEquals?: string, contextCodeIn?: Array<string>, contextCodeNotEquals?: string, contextCodeSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, logoImageContains?: string, logoImageDoesNotContain?: string, logoImageEquals?: string, logoImageIn?: Array<string>, logoImageNotEquals?: string, logoImageSpecified?: boolean, nameContains?: string, nameDoesNotContain?: string, nameEquals?: string, nameIn?: Array<string>, nameNotEquals?: string, nameSpecified?: boolean, nameDatabaseContains?: string, nameDatabaseDoesNotContain?: string, nameDatabaseEquals?: string, nameDatabaseIn?: Array<string>, nameDatabaseNotEquals?: string, nameDatabaseSpecified?: boolean, page?: number, size?: number, sort?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TenantContextDTO>>>;
    public getAllTenantContextsUsingGET(contextCodeContains?: string, contextCodeDoesNotContain?: string, contextCodeEquals?: string, contextCodeIn?: Array<string>, contextCodeNotEquals?: string, contextCodeSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, logoImageContains?: string, logoImageDoesNotContain?: string, logoImageEquals?: string, logoImageIn?: Array<string>, logoImageNotEquals?: string, logoImageSpecified?: boolean, nameContains?: string, nameDoesNotContain?: string, nameEquals?: string, nameIn?: Array<string>, nameNotEquals?: string, nameSpecified?: boolean, nameDatabaseContains?: string, nameDatabaseDoesNotContain?: string, nameDatabaseEquals?: string, nameDatabaseIn?: Array<string>, nameDatabaseNotEquals?: string, nameDatabaseSpecified?: boolean, page?: number, size?: number, sort?: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




































        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (contextCodeContains !== undefined && contextCodeContains !== null) {
            queryParameters = queryParameters.set('contextCode.contains', <any>contextCodeContains);
        }
        if (contextCodeDoesNotContain !== undefined && contextCodeDoesNotContain !== null) {
            queryParameters = queryParameters.set('contextCode.doesNotContain', <any>contextCodeDoesNotContain);
        }
        if (contextCodeEquals !== undefined && contextCodeEquals !== null) {
            queryParameters = queryParameters.set('contextCode.equals', <any>contextCodeEquals);
        }
        if (contextCodeIn) {
            contextCodeIn.forEach((element) => {
                queryParameters = queryParameters.append('contextCode.in', <any>element);
            })
        }
        if (contextCodeNotEquals !== undefined && contextCodeNotEquals !== null) {
            queryParameters = queryParameters.set('contextCode.notEquals', <any>contextCodeNotEquals);
        }
        if (contextCodeSpecified !== undefined && contextCodeSpecified !== null) {
            queryParameters = queryParameters.set('contextCode.specified', <any>contextCodeSpecified);
        }
        if (idEquals !== undefined && idEquals !== null) {
            queryParameters = queryParameters.set('id.equals', <any>idEquals);
        }
        if (idGreaterThan !== undefined && idGreaterThan !== null) {
            queryParameters = queryParameters.set('id.greaterThan', <any>idGreaterThan);
        }
        if (idGreaterThanOrEqual !== undefined && idGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.greaterThanOrEqual', <any>idGreaterThanOrEqual);
        }
        if (idIn) {
            idIn.forEach((element) => {
                queryParameters = queryParameters.append('id.in', <any>element);
            })
        }
        if (idLessThan !== undefined && idLessThan !== null) {
            queryParameters = queryParameters.set('id.lessThan', <any>idLessThan);
        }
        if (idLessThanOrEqual !== undefined && idLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.lessThanOrEqual', <any>idLessThanOrEqual);
        }
        if (idNotEquals !== undefined && idNotEquals !== null) {
            queryParameters = queryParameters.set('id.notEquals', <any>idNotEquals);
        }
        if (idSpecified !== undefined && idSpecified !== null) {
            queryParameters = queryParameters.set('id.specified', <any>idSpecified);
        }
        if (logoImageContains !== undefined && logoImageContains !== null) {
            queryParameters = queryParameters.set('logoImage.contains', <any>logoImageContains);
        }
        if (logoImageDoesNotContain !== undefined && logoImageDoesNotContain !== null) {
            queryParameters = queryParameters.set('logoImage.doesNotContain', <any>logoImageDoesNotContain);
        }
        if (logoImageEquals !== undefined && logoImageEquals !== null) {
            queryParameters = queryParameters.set('logoImage.equals', <any>logoImageEquals);
        }
        if (logoImageIn) {
            logoImageIn.forEach((element) => {
                queryParameters = queryParameters.append('logoImage.in', <any>element);
            })
        }
        if (logoImageNotEquals !== undefined && logoImageNotEquals !== null) {
            queryParameters = queryParameters.set('logoImage.notEquals', <any>logoImageNotEquals);
        }
        if (logoImageSpecified !== undefined && logoImageSpecified !== null) {
            queryParameters = queryParameters.set('logoImage.specified', <any>logoImageSpecified);
        }
        if (nameContains !== undefined && nameContains !== null) {
            queryParameters = queryParameters.set('name.contains', <any>nameContains);
        }
        if (nameDoesNotContain !== undefined && nameDoesNotContain !== null) {
            queryParameters = queryParameters.set('name.doesNotContain', <any>nameDoesNotContain);
        }
        if (nameEquals !== undefined && nameEquals !== null) {
            queryParameters = queryParameters.set('name.equals', <any>nameEquals);
        }
        if (nameIn) {
            nameIn.forEach((element) => {
                queryParameters = queryParameters.append('name.in', <any>element);
            })
        }
        if (nameNotEquals !== undefined && nameNotEquals !== null) {
            queryParameters = queryParameters.set('name.notEquals', <any>nameNotEquals);
        }
        if (nameSpecified !== undefined && nameSpecified !== null) {
            queryParameters = queryParameters.set('name.specified', <any>nameSpecified);
        }
        if (nameDatabaseContains !== undefined && nameDatabaseContains !== null) {
            queryParameters = queryParameters.set('nameDatabase.contains', <any>nameDatabaseContains);
        }
        if (nameDatabaseDoesNotContain !== undefined && nameDatabaseDoesNotContain !== null) {
            queryParameters = queryParameters.set('nameDatabase.doesNotContain', <any>nameDatabaseDoesNotContain);
        }
        if (nameDatabaseEquals !== undefined && nameDatabaseEquals !== null) {
            queryParameters = queryParameters.set('nameDatabase.equals', <any>nameDatabaseEquals);
        }
        if (nameDatabaseIn) {
            nameDatabaseIn.forEach((element) => {
                queryParameters = queryParameters.append('nameDatabase.in', <any>element);
            })
        }
        if (nameDatabaseNotEquals !== undefined && nameDatabaseNotEquals !== null) {
            queryParameters = queryParameters.set('nameDatabase.notEquals', <any>nameDatabaseNotEquals);
        }
        if (nameDatabaseSpecified !== undefined && nameDatabaseSpecified !== null) {
            queryParameters = queryParameters.set('nameDatabase.specified', <any>nameDatabaseSpecified);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (sort) {
            sort.forEach((element) => {
                queryParameters = queryParameters.append('sort', <any>element);
            })
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<TenantContextDTO>>('get',`${this.basePath}/m8t/api/tenant-contexts`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getTenantContext
     * 
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTenantContextUsingGET(id: number, observe?: 'body', reportProgress?: boolean): Observable<TenantContextDTO>;
    public getTenantContextUsingGET(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TenantContextDTO>>;
    public getTenantContextUsingGET(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TenantContextDTO>>;
    public getTenantContextUsingGET(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getTenantContextUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<TenantContextDTO>('get',`${this.basePath}/m8t/api/tenant-contexts/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateTenantContext
     * 
     * @param body tenantContextDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateTenantContextUsingPUT(body: TenantContextDTO, observe?: 'body', reportProgress?: boolean): Observable<TenantContextDTO>;
    public updateTenantContextUsingPUT(body: TenantContextDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TenantContextDTO>>;
    public updateTenantContextUsingPUT(body: TenantContextDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TenantContextDTO>>;
    public updateTenantContextUsingPUT(body: TenantContextDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateTenantContextUsingPUT.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<TenantContextDTO>('put',`${this.basePath}/m8t/api/tenant-contexts`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
